import React, { useEffect, useState } from "react";
import s from './billtest.module.css';
import {getData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";
import {GreenButton, BlueButton, RedButton} from '../components/MyButton';
import svgtestSvg from'../asset/svgtest.svg';
import {
  useSearchParams
} from "react-router-dom";
import {modifiedDate} from '../middleware/dateControl';

export default function Billtest() {
	const navigate = useNavigate();
	
	const fetchData = () => {	
	}
	
	useEffect(() => {
	}, []);
	
	return (<div>
		<div style={{margin:"10px", fontSize:"0.8rem"}}>
		<img src={svgtestSvg} alt="icon"/>
		</div>
	</div>);
}

